export enum TermsChangeOption {
  RaisedRange = 'Raised Range',
  LowerRange = 'Lowered Range',
  NoChange = 'No change',
  All = '',
}
